<template>
  <v-dialog v-bind='dialog' :disabled='!$store.state.loginSettings.adminAvailable && player.score === null'>
    <template v-slot:activator='{on}'>
      <v-container class='bracket-item' v-on='on'>
        <v-row>
          <v-col cols='1' style='font-weight: 700'>{{player.seed !== undefined ? player.seed + 1 : ''}}</v-col>
          <v-col cols='8'>
            <a v-if='player.wcaID' :href='`https://www.worldcubeassociation.org/persons/${player.wcaID}`'>{{player.name}}</a>
            <span v-else>{{player.name}}</span>
          </v-col>
          <v-col cols='3'>
            <v-chip dark small>{{player.score === null ? '-' : player.score}}<v-icon v-if='player.score !== null' x-small style='padding-left: 4px;'>fas fa-external-link-alt</v-icon></v-chip>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <v-card>
      <h1>Matchup</h1>
      <review-table :solverData='matchupData' />
    </v-card>
  </v-dialog>
</template>

<script>
import ReviewTable from '@/components/TPC/Shared/ReviewTable'

export default {
  name: 'bracket-item',
  components: {
    ReviewTable
  },
  data () {
    return {
      dialog: false,
    }
  },
  props: {
    player: Object
  },
  computed: {
    matchupData () {
      return this.player && this.player.matchupData && this.player.matchupData.map((v) => (v ? {...v, solveTimes: v.times} : undefined))
    },
  }
}
</script>

<style scoped>
a {
  font-weight: 500;
  line-height: 2;
}
.col, .container {
  padding: 0
}
.theme--dark.v-chip:not(.v-chip--active) {
  background-color: rgba(80, 80, 80, 0.8);
}
.bracket-item {
  padding: 5px 10px 5px 10px;
}
</style>
